import React from 'react';
import './Summary.css';
import CruiseDetails from '../cruise-details/cruise-details';
import TravelProtection from '../travel-protection/travel-protection';
import SummaryCharges from '../summary-charges/summary-charges';
import PaymentInformation from "../payment-information/payment-information";
import LandDetails from "../land-details/land-details";
import InvoiceDetails from "../invoice-details/invoice-details";
import Helmet from "react-helmet/es/Helmet";

class Summary extends React.Component {

    constructor(props) {
        super(props);
        this.paymentFormRef = React.createRef();
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;

        this.state = {
            showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            charges: {
                totalWithOutInsurance: this.booking.totalWithOutInsurance,
                insuranceTotal: this.booking.insuranceTotal,
                paymentsReceived: this.booking.paymentsReceived,
                pendingPaymentTotal: this.booking.pendingPaymentTotal,
                remainingBalanceIncludingInsurance: this.booking.remainingBalanceIncludingInsurance,
                remainingBalanceExcludingInsurance: this.booking.remainingBalanceExcludingInsurance,
                nextPaymentDueDate: this.booking.nextPaymentDueDate,
                finalPaymentDate: this.booking.finalPaymentDate,
                includeInsurance: this.booking.remainingBalanceIncludingInsurance !== this.booking.remainingBalanceExcludingInsurance,
                currentAmount: 0
            }
        }
        this.daysBeforePaymentDueDate = 0;

        window.dataLayer = window.dataLayer || [];
        try {
            var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
                window.dataLayer.push({
                    'event': 'VirtualPageview',
                    'virtualPageURL': 'gaVirtualPageURL',
                    'virtualPagePath': '/css/guest/',
                    'virtualPageTitle': 'Customer Self Service'
    
                });
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
                window.dataLayer.push({
                    'event': 'VirtualPageview',
                    'virtualPageURL': 'gaVirtualPageURL',
                    'virtualPagePath': '/css/guest/',
                    'virtualPageTitle': 'Customer Self Service'
    
                });
			} else {
				console.log("off");    
			}
         
        } catch (error) {
            //swallow error
        }
    }
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    render = () => {
        const hash = this.props.hash;
        //const attributes = this.props.attributes;
        return (
            <div className="rea-appContainer">
                <Helmet>
                    <title>Customer Self Service / Summary</title>
                </Helmet>
                <div className="rea-block-row">
                    <div className="rea-block-12">
                        <div class="rea-block-row rea-pageHeader">
                            <div className="rea-block-6 rea-padding-0">
                                <div className="rea-pageHeaderTitle">BOOKING SUMMARY</div>
                            </div>
                            <div className="rea-block-6 rea-padding-0 rea-paymentBtnContainer">
                                {
                                    this.showPaymentForm() &&
                                    <a href="# " className="btn wth2-ui-btn rea-paymentBtn"
                                       onClick={e=> {e.preventDefault();this.scrollToPaymentForm()}}><i
                                        className="fa fa-credit-card"></i> Make a Payment</a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rea-block-row rea-summaryDetailsContainer">
                    <div class="rea-block-12">
                        <div className="rea-block-row">
                            <div className="rea-block-12">
                                {
                                    (this.booking.bookingType.toLowerCase() === 'cruise' &&
                                        <CruiseDetails booking={this.booking}
                                                       showItineraryLink={false}
                                                       showGuests={true}/>) || (this.booking.bookingType.toLowerCase() === 'land' &&
                                        <LandDetails showItineraryLink={false} booking={this.booking}
                                                     showGuests={true}/>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rea-block-row rea-summaryProtectionContainer">
                    <div className="rea-block-12">
                        <div className="rea-block-row">
                            <div className="rea-block-12">
                                <TravelProtection booking={this.booking}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rea-block-row rea-summaryDetailsContainer">
                    <div className="rea-block-12">
                        <div className="rea-summaryContainer rea-block-row">
                            <div className="rea-block-7" ref={this.paymentFormRef}>
                                <SummaryCharges charges={this.state.charges}/>
                            </div>
                            {
                                this.booking.invoiceLinkUrl &&
                                <div className="rea-block-5 rea-termsContainer">
                                    <div className="rea-termsConditions">
                                        <InvoiceDetails invoice={this.booking} showItineraryButton={false}
                                                        showInvoiceDisclaimer={true}/>
                                    </div>
                                </div>
                            }
                        </div>
                        {
                            this.showPaymentForm() &&
                            <div className="rea-paymentContainer rea-block-row">
                                <div className="rea-block-12">
                                    <PaymentInformation booking={this.booking} hash={hash}
                                                        onPaymentSubmit={this.onPaymentSubmit}
                                                        onPaymentError={this.onPaymentError}/>
                                </div>
                            </div>
                        }
                        {
                            !this.showPaymentForm() && (this.booking.remainingBalanceIncludingInsurance > 0 || this.booking.remainingBalanceExcludingInsurance > 0) &&
                            <div class="wth2-warningMessage">
                                <i class="fa fa-exclamation-circle"></i>
                                <div class="wth2-warningMessageHeader">Payments cannot be processed online at this
                                    time.
                                </div>
                                <div>Please call <strong>{this.franchiseData.mainPhoneNumber}</strong> to speak with
                                    your vacation specialist to make
                                    a payment for this booking.
                                </div>
                            </div>
                        }
                        {
                            !this.showPaymentForm() && this.booking.remainingBalanceIncludingInsurance <= 0 && this.booking.remainingBalanceExcludingInsurance <= 0 && this.booking.pendingPaymentTotal === 0 &&
                            <div className="wth2-warningMessage">
                                <i className="fa fa-exclamation-circle"></i>
                                <div className="wth2-warningMessageHeader">Payments cannot be processed online at this
                                    time.
                                </div>
                                <div>Your booking is paid in full as per the information that we have on file. Please
                                    call <strong>{this.franchiseData.mainPhoneNumber}</strong> to speak with your
                                    vacation specialist if you need further assistance.
                                </div>
                            </div>
                        }
                        {
                            !this.showPaymentForm() && this.booking.remainingBalanceIncludingInsurance <= 0 && this.booking.remainingBalanceExcludingInsurance <= 0 && this.booking.pendingPaymentTotal > 0 &&
                            <div className="wth2-warningMessage">
                                <i className="fa fa-exclamation-circle"></i>
                                <div className="wth2-warningMessageHeader">Payments cannot be processed online at this
                                    time.
                                </div>
                                <div>Additional payments cannot be processed online at this time. Please
                                    call <strong>{this.franchiseData.mainPhoneNumber}</strong> to speak with your
                                    vacation specialist if you need further assistance.
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    showPaymentForm = () => {
        let finalPaymentDate = new Date(this.booking.finalPaymentDate);
        finalPaymentDate = new Date(finalPaymentDate.setDate(finalPaymentDate.getDate() + this.daysBeforePaymentDueDate));
        let currentDate = new Date();
        currentDate = new Date(currentDate.setHours(0, 0, 0, 0));
        let allowOnlinePaymentsInSwapStoreCode = (this.franchiseData !== undefined && this.franchiseData.storeCodeFlags !== undefined && this.franchiseData.storeCodeFlags[0] !== undefined && this.franchiseData.storeCodeFlags[0].PCS === 'Y');
        return (this.booking.remainingBalanceIncludingInsurance > 0 || this.booking.remainingBalanceExcludingInsurance > 0) && allowOnlinePaymentsInSwapStoreCode && this.booking.allowOnlinePayments && finalPaymentDate >= currentDate;
    }

    onPaymentSubmit = (jsonPaymentResponse) => {
        this.props.onPaymentSubmit(jsonPaymentResponse);
    }

    onPaymentError = (error) => {
        this.props.onPaymentError(error);
    }

    scrollToPaymentForm = (event) => {
        this.paymentFormRef.current.scrollIntoView({behavior: "smooth"});
    }
}

export default Summary;
